import { CryptoContext } from '../base';
import { RoomKeyConfigDumpArgs, RoomKeyConfigLoadArgs } from './args';
import { RoomKeyConfigV1 } from './v1';
import { CU_ANNULLED_BY_PQC_ML, CU_PQC_ML } from '../feature';
import { RoomKeyConfigV2, RoomKeyConfigV3 } from './v2_v3';

export let ROOM_KEY_CRYPTO_CONTEXT = new CryptoContext<
  RoomKeyConfigLoadArgs,
  RoomKeyConfigDumpArgs
>([
  new RoomKeyConfigV1(CU_ANNULLED_BY_PQC_ML),
  new RoomKeyConfigV2(CU_PQC_ML),
  new RoomKeyConfigV3(CU_PQC_ML),
]);
